import * as React from 'react';

type PauseSvgProps = React.SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
};

const PauseSvg: React.FC<PauseSvgProps> = ({ width = 28, height = 28, ...props }) => {
  return (
    <svg width={width} height={height} {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5002 22.1668C16.8585 22.1668 16.3092 21.9384 15.8522 21.4814C15.3953 21.0245 15.1668 20.4752 15.1668 19.8335V8.16683C15.1668 7.52516 15.3953 6.97586 15.8522 6.51891C16.3092 6.06197 16.8585 5.8335 17.5002 5.8335H19.8335C20.4752 5.8335 21.0245 6.06197 21.4814 6.51891C21.9384 6.97586 22.1668 7.52516 22.1668 8.16683V19.8335C22.1668 20.4752 21.9384 21.0245 21.4814 21.4814C21.0245 21.9384 20.4752 22.1668 19.8335 22.1668H17.5002ZM8.16683 22.1668C7.52516 22.1668 6.97586 21.9384 6.51891 21.4814C6.06197 21.0245 5.8335 20.4752 5.8335 19.8335V8.16683C5.8335 7.52516 6.06197 6.97586 6.51891 6.51891C6.97586 6.06197 7.52516 5.8335 8.16683 5.8335H10.5002C11.1418 5.8335 11.6911 6.06197 12.1481 6.51891C12.605 6.97586 12.8335 7.52516 12.8335 8.16683V19.8335C12.8335 20.4752 12.605 21.0245 12.1481 21.4814C11.6911 21.9384 11.1418 22.1668 10.5002 22.1668H8.16683ZM17.5002 19.8335H19.8335V8.16683H17.5002V19.8335ZM8.16683 19.8335H10.5002V8.16683H8.16683V19.8335Z"
        fill="white"
      />
    </svg>
  );
};

export default PauseSvg;
